(function () {
    if (window.__imagesCarouselHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.imagesCarousel = window.Branch.imagesCarousel || {};
    window.Branch.imagesCarousel.sliders = window.Branch.imagesCarousel.sliders || {};
    window.__imagesCarouselHasFired = true;

    function initImagesCarouselSlider(imagesCarouselSection, parent){
        let slides = imagesCarouselSection.querySelectorAll('.images-carousel__item.swiper-slide')
        let cascadeIndex = parseInt(slides[0].getAttribute('data-cascade-order'));

        imagesCarouselSection.querySelectorAll('.images-carousel__item.swiper-slide').forEach((updatedSlide, index) => {
        updatedSlide.setAttribute('data-cascade-order', `${cascadeIndex}`);
        const width = window.innerWidth;

        if (
            (width < 900 && index < 2) ||
            (width < 1024 && index < 3) ||
            (width >= 1024 && index < 4)
        ) {
            cascadeIndex++;
        }
    });
        let parentId = parent.getAttribute('id');
        let enable_autoscroll = imagesCarouselSection.getAttribute('data-enable-autoscroll') == 'true';
        let autoscroll_interval = 1000 * parseInt(imagesCarouselSection.getAttribute('data-autoscroll-interval'));
        let desktop_images_across = parseFloat(imagesCarouselSection.getAttribute('data-desktop-images-across'));
        console.log('desktop_images_across!', desktop_images_across)
        let autoplay = !enable_autoscroll ? false : {delay: autoscroll_interval, disableOnInteraction: true}
        
        window.Branch.imagesCarousel.sliders[`${parentId}`] = new Swiper(`#${parentId} .images-carousel__slider`, {
            spaceBetween: 20,
            slidesPerView: 1.1,
            autoplay: autoplay,
            touchRatio: 0.2,
            loop: false,
            navigation: {
                nextEl: `#${parentId} .images-carousel__nav-right`,
                prevEl: `#${parentId} .images-carousel__nav-left`,
            },
            breakpoints: {
                600: {
                        slidesPerView: 1.5,
                },
                900: {
                        slidesPerView: 2.5,
                },
                1024: {
                        slidesPerView: desktop_images_across,
                }
            }
        });
    }

function actionsOnVisible(imagesCarouselSection, parent){
    console.log('actionsOnVisible image carousel')
        imagesCarouselSection.setAttribute('data-interacted', true);
        window.Branch.nav.handleUpdateSrcSet(null, '.images-carousel__image', '.images-carousel__image-container', 900);     
        initImagesCarouselSlider(imagesCarouselSection, parent);
    }    

function initImageCarouselCallback(imagesCarouselSection, parent, type){
        let fromLoad = imagesCarouselSection.closest('.homepage-content-container') && imagesCarouselSection.closest('.homepage-content-container').getAttribute('data-origin') == 'load';

        if(type == 'from-copy' && fromLoad == false){
            actionsOnVisible(imagesCarouselSection, parent);
        } else if(!imagesCarouselSection.closest('.homepage-content-container')) {
            actionsOnVisible(imagesCarouselSection, parent);
        } else {
            const scrollHandler = function () {
            const containerRect = {top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth, width: window.innerWidth, height: window.innerHeight};
            const targetRect = imagesCarouselSection.getBoundingClientRect();

            const isVisible =
                targetRect.bottom > containerRect.top &&
                targetRect.top < containerRect.bottom;

            if (
                isVisible &&
                imagesCarouselSection.getAttribute("data-interacted") !== "true"
            ) {
                actionsOnVisible(imagesCarouselSection, parent);
                imagesCarouselSection.setAttribute("data-interacted", "true");
                window.removeEventListener("scroll", scrollHandler);
            }
        };

        window.addEventListener("scroll", scrollHandler);
        }
    }

    window.Branch.imagesCarousel.imagesCarouselInitOnLoad = function(type){
        let imagesCarouselSections = document.querySelectorAll('.images-carousel:not([data-initialized="true"])');
        imagesCarouselSections.forEach((imagesCarouselSection) => {
            let parent = imagesCarouselSection.closest('.shopify-section');
            imagesCarouselSection.setAttribute('data-initialized', true);
            if(type == 'from-copy'){
                 initImageCarouselCallback(imagesCarouselSection, parent, type)
            } else {
                 window.Branch.functions.fireOnUserInteraction(initImageCarouselCallback, '.homepage-content-container', imagesCarouselSection, imagesCarouselSection, parent);
             }
        })  
    }

    if (document.readyState === "complete") {
        window.Branch.imagesCarousel.imagesCarouselInitOnLoad('regular'); 
    } else {
        window.addEventListener("load", () => window.Branch.imagesCarousel.imagesCarouselInitOnLoad('regular'));
    }
  })();
